import * as React from "react";
import {database, storage} from "../../firebase";
import {CharityForm} from "./CharityForm";
import {connect} from "react-redux";
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {
  charityCurrentlyEditingAction,
  clearSavedCharityAction,
  extractCharityFormData,
  savedCharityAction,
  savingCharityAction
} from "./CharityOperations";
import {fetchAllStripeConnectAccounts} from "../stripe-connect";

export interface CharityEditProps {
  match: any;
  charity: any;
  stripeAccounts: any;
  saved: boolean;
  saving: boolean;
  setCurrentlyEditingCharity: (charity: any) => void;
  setImageForCurrentlyEditingCharity: (image: any) => void;
  removeImage: () => void;
  setSaving: () => void;
  setSaved: () => void;
  clearSaved: () => void;
  getStripeConnectAccounts: () => void;
  auth: any;
  classes: any;
}

const styles = {
  heading: {
    margin: '60px 0',
    textTransform: 'uppercase'
  }
}

export class CharityEditContainer extends React.Component<CharityEditProps> {
  private charitiesRef: any;
  private storageRef: any;

  constructor(props: any) {
    super(props);
    this.charitiesRef = database.ref("/charities");
    this.storageRef = storage.ref("/charity-images");
  }

  render() {
    const {charity, saved, saving, setSaved, setSaving, clearSaved, stripeAccounts, auth, classes, paypalAccounts} = this.props;
    if (!charity) {
      return <div/>;
    }
    const handleSubmit = (values: any): void => {
      setSaving();
      const {logoImgName, logoImgUrl, mobileLogoImgName, mobileLogoImgUrl} = this.props.charity;
      const charityData = {...values, logoImgName, logoImgUrl, mobileLogoImgName, mobileLogoImgUrl};
      const updatedCharity = extractCharityFormData(charityData);
      updatedCharity.stripeAccount = updatedCharity.stripeAccount || null;
      updatedCharity.paypalAccount = updatedCharity.paypalAccount || null;
      const charityId = this.props.match.params.uid;
      this.charitiesRef
        .child(charityId)
        .update(updatedCharity)
        .then(() => {
          setSaved();
          setTimeout(() => clearSaved(), 3000);
        });
    };
    return (
      <div>
        <div className={classes.heading} >
          <Typography variant="display1">{auth.isAdmin ? 'Edit Charity': 'Charity Info'}</Typography>
        </div>
        {
          saving === true && <div><i className="fa fa-spinner" aria-hidden="true"/> Saving...</div>
        }
        {
          saved === true &&
          <div className="notification is-primary">
            Saved successfully
          </div>
        }
        <CharityForm
          stripeAccounts={stripeAccounts}
          paypalAccounts={paypalAccounts}
          onSubmit={handleSubmit}
          submitting={saving}
        />
      </div>
    );
  }

  componentWillMount() {
    const charityId = this.props.match.params.uid;
    const {setCurrentlyEditingCharity, getStripeConnectAccounts} = this.props;
    this.charitiesRef.child(charityId).once("value", (snapshot) => {
      if (snapshot.val()) {
        const charity = snapshot.val();
        setCurrentlyEditingCharity(charity);
      }
    });
    getStripeConnectAccounts();
  }
}

const mapStateToProps = (state) => ({
  charity: state.charities.currentlyEditingCharity,
  saving: state.charities.saving,
  saved: state.charities.saved,
  stripeAccounts: state.stripe.accounts,
  paypalAccounts: state.paypal.accounts,
  auth: state.auth
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentlyEditingCharity: (charity) => dispatch(charityCurrentlyEditingAction(charity)),
  setSaving: () => dispatch(savingCharityAction()),
  setSaved: () => dispatch(savedCharityAction()),
  clearSaved: () => dispatch(clearSavedCharityAction()),
  getStripeConnectAccounts: () => dispatch(fetchAllStripeConnectAccounts())
});
export const CharityEdit = withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(CharityEditContainer));
